import { Component, OnInit } from '@angular/core';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { environment } from '@environments/environment';
import { UserClassesService } from '@services/user-classes.service';
import { saveAs } from 'file-saver';
import { timeout, retry, catchError, finalize } from 'rxjs/operators';
import { ErrorHandlerService } from '@services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  urlCertificate: string;
  isDownloading: boolean = false;

  constructor(
    public authService: AuthService,
    private alertify: AlertifyService, 
    private userClassesService: UserClassesService,
    private errorHandler: ErrorHandlerService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

  ngOnInit() {
    this.checkCertificateAvailability();
  }

  private checkCertificateAvailability(): void {
    if (this.authService.loggedIn() && this.authService.getCourseCompleted() === 'true') {
      const userId = this.authService.returnCurrentUser().id;
      this.userClassesService.CheckCertificateAvailability(userId)
        .subscribe({
          next: (result) => {
            if (!result.available) {
              console.warn('Certificate not available:', result.reason);
            }
          },
          error: (error) => console.error('Certificate availability check failed:', error)
        });
    }
  }

  existsCertificate() {
    if (this.authService.getCourseCompleted() == 'false') {
      return false;
    }
    return true;
  }

  downloadCertificate(): void {
    if (!this.canDownloadCertificate()) {
      this.translate.get(["ALERTIFY.CERTIFICATE_COURSE_INCOMPLETE", "BOOTSTRAP.MODAL.WARNING"]).subscribe((text: string) => {
        this.alertify.warning(text)

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.WARNING'],
          modal_body_html: text['ALERTIFY.CERTIFICATE_COURSE_INCOMPLETE'],
          modal_color_variant: "warning"
        })
      });
      return;
    }
  
    this.isDownloading = true;
    const userId = this.authService.returnCurrentUser().id;
  
    this.userClassesService.GetCertificatePdf(userId)
      .pipe(
        timeout(30000), // 30 second timeout
        retry(2), // Retry twice on failure
        finalize(() => this.isDownloading = false)
      )
      .subscribe({
        next: (fileData) => {          
          saveAs(fileData, 'certificate.pdf')
          console.log('Certificate downloaded successfully')
          this.translate.get(["ALERTIFY.CERTIFICATE_DOWNLOAD_SUCCESSFULLY", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
            this.alertify.success(text)

            this.bootstrap_modal.open({
              modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
              modal_body_html: text['ALERTIFY.CERTIFICATE_DOWNLOAD_SUCCESSFULLY'],
              modal_color_variant: "success"
            })

          });
        },
        error: (error) => this.errorHandler.handleCertificateError(error)
      });
  }
  private canDownloadCertificate(): boolean {
    return this.authService.getCourseCompleted() === 'true';
  }

  /*downloadCertificate() {
    // console.log("Course Completed: " + this.authService.getCourseCompleted());
    // console.log("Click" );
    if (this.authService.getCourseCompleted() == 'true') {
      let userId = this.authService.returnCurrentUser().id;

      this.userClassesService.GetCertificatePdf(userId).subscribe(fileData => {
        console.log(fileData);
        saveAs(fileData, 'certificate.pdf');

        let blob: Blob = new Blob([fileData], { type: 'application/ pdf' });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(blob);
        //   return;
        // }
      }, error => {
        //this.alertify.error(error); //  'Failed to loginsss');
      }, () => {
        //  this.router.navigate(['/login']);
      }
      );
    }
  }*/

}
